import { Minus, Plus } from 'lucide-react'

/**
 * QtyStepper — quantity control for a cart line.
 *
 *   −  [ 12 ]  +
 *
 * The −/+ buttons handle the common "one more / one less" nudge. The number in
 * the middle is a button: tapping it opens the NumPad sheet (via `onTap`) so a
 * cashier can type "50" in one go instead of tapping + fifty times — the exact
 * thing the old PWA couldn't do.
 *
 *   value     current quantity (in the selected unit), integer ≥ 1
 *   max       largest allowed (stock, in the selected unit) — caps the + button
 *   onChange  (next:number) => void   from the steppers
 *   onTap     open the keypad to type a value
 */
export default function QtyStepper({ value, max, onChange, onTap }) {
  const atMin = value <= 1
  const atMax = max != null && value >= max

  return (
    <div className="flex items-center rounded-xl bg-white ring-1 ring-sage-200 overflow-hidden shadow-sm">
      <button
        type="button"
        aria-label="Decrease quantity"
        disabled={atMin}
        onClick={() => onChange(Math.max(1, value - 1))}
        className="h-11 w-11 grid place-items-center text-brand-600 active:bg-brand-50 disabled:opacity-25 disabled:active:bg-transparent"
      >
        <Minus size={16} strokeWidth={2.75} />
      </button>

      <button
        type="button"
        onClick={onTap}
        aria-label="Type quantity"
        className="h-11 min-w-[3rem] px-2 grid place-items-center text-lg font-bold tabular-nums text-sage-900 border-x border-sage-100 active:bg-sage-50"
      >
        {value}
      </button>

      <button
        type="button"
        aria-label="Increase quantity"
        disabled={atMax}
        onClick={() => onChange(value + 1)}
        className="h-11 w-11 grid place-items-center text-brand-600 active:bg-brand-50 disabled:opacity-25 disabled:active:bg-transparent"
      >
        <Plus size={16} strokeWidth={2.75} />
      </button>
    </div>
  )
}
